var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass: "speaker-card",
      attrs: { href: _vm.route("nl.speaker", { slug: _vm.speaker.post_name }) }
    },
    [
      _c("div", { ref: "card", staticClass: "media-container mb-12" }, [
        _c(
          "div",
          {
            ref: "ar",
            staticClass: "ar",
            style: { "padding-top": (_vm.arHeight / _vm.arWidth) * 100 + "%" }
          },
          [
            _c(
              "div",
              { staticClass: "images" },
              [
                _vm.speaker.acf && _vm.speaker.acf.image
                  ? [
                      _c("img", {
                        ref: "primary",
                        staticClass: "primary-image",
                        attrs: {
                          src: _vm.speaker.acf.image.sizes.medium_large,
                          alt: _vm.speaker.post_title
                        }
                      })
                    ]
                  : _vm._e()
              ],
              2
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "title lh-1" }, [
        _vm._v(_vm._s(_vm.speaker.post_title))
      ]),
      _vm._v(" "),
      _vm.speaker.acf &&
      _vm.speaker.acf.highlighted_title &&
      !_vm.$root.isMobile
        ? _c(
            "p",
            { staticClass: "text-dark font-weight-light small mt-8 subtitle" },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.speaker.acf.highlighted_title) +
                  "\n    "
              )
            ]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }